
// **** Autogenerated. Do NOT edit. ****

package uk.co.nickthecoder.glok.property.boilerplate

import uk.co.nickthecoder.glok.property.*
import uk.co.nickthecoder.glok.theme.Theme
import uk.co.nickthecoder.glok.documentation.Boilerplate
import uk.co.nickthecoder.glok.documentation.PropertyFunctions 


// region ==== Basic Features ====

/**
 * [Boilerplate] which avoids having to use generics.
 * Instead of `ObservableValue<Theme>`, use `ObservableTheme`.
 */
interface ObservableTheme: ObservableValue<Theme> {}

/**
 * [Boilerplate] which avoids having to use generics.
 * Instead of `ReadOnlyProperty<Theme>`, use `ReadOnlyThemeProperty`.
 */
interface ReadOnlyThemeProperty : ObservableTheme, ReadOnlyProperty<Theme>

/**
 * [Boilerplate] which avoids having to use generics.
 * Instead of `Property<Theme>`, use `ThemeProperty`.
 */
interface ThemeProperty : Property<Theme>, ReadOnlyThemeProperty {

    /**
     * Returns a read-only view of this mutable ThemeProperty.
     * Typical usage :
     *
     *     private val mutableFooProperty by ThemeProperty( initialValue )
     *     val fooProperty = mutableFooProperty.asReadOnly()
     *     val foo by mutableFooProperty
     *         private set
     *
     * This give `private` access to the mutable property, and the mutable `var`, but the public
     * only has read-only access.
     */
    fun asReadOnly() : ReadOnlyThemeProperty = ReadOnlyThemePropertyWrapper( this )
}

/**
 * [Boilerplate] which avoids having to use generics.
 * Instead of `SimpleProperty<Theme>`, we can use `SimpleThemeProperty`.
 */
open class SimpleThemeProperty(initialValue: Theme, bean: Any? = null, beanName: String? = null) :
    SimpleProperty<Theme>(initialValue, bean, beanName), ThemeProperty

/**
 * Never use this class directly.
 * Use [ThemeProperty.asReadOnly] to obtain a read-only version of a mutable [ThemeProperty].
 *
 * [Boilerplate] which avoids having to use generic.
 * Instead of `ReadOnlyPropertyWrapper<Theme, Property<Theme>>`, use `ReadOnlyThemePropertyWrapper`.
 */
class ReadOnlyThemePropertyWrapper(wraps: ThemeProperty) :
    ReadOnlyPropertyWrapper<Theme, Property<Theme>>(wraps), ReadOnlyThemeProperty


// endregion Basic Features

// region ==== Delegate ====

/**
 * A Kotlin `delegate` to create a [ThemeProperty] (the implementation will be a [SimpleThemeProperty].
 * Typical usage :
 *
 *     val fooProperty by themeProperty( initialValue )
 *     var foo by fooProperty
 *
 */
fun themeProperty(initialValue: Theme) = PropertyDelegate<Theme,ThemeProperty>(initialValue) { bean, name, value ->
    SimpleThemeProperty(value, bean, name)
}


//endregion Delegate

// region ==== Functions ====

/**
 * [Boilerplate] which avoids having to use generics.
 * An [ObservableTheme] which is calculated from 1 (unary) other [ObservableValue].
 *
 * See [UnaryFunction] ([PropertyFunctions]).
 */
class ThemeUnaryFunction<A, OA : ObservableValue<A>>(argA: OA, lambda: (A) -> Theme) :
    UnaryFunction<Theme, A, OA>(argA, lambda), ObservableTheme

/**
 * [Boilerplate] which avoids having to use generics.
 * An [ObservableTheme] which is calculated from 2 (binary) other [ObservableValue]s.
 *
 * See [BinaryFunction] ([PropertyFunctions]).
 */
class ThemeBinaryFunction<A, OA : ObservableValue<A>, B, OB : ObservableValue<B>>(argA: OA, argB: OB, lambda: (A, B) -> Theme) :
    BinaryFunction<Theme, A, OA, B, OB>(argA, argB, lambda), ObservableTheme

/**
 * [Boilerplate] which avoids having to use generics.
 * An [ObservableTheme] which is calculated from 3 (ternary) other [ObservableValue]s.
 *
 * See [BinaryFunction] ([PropertyFunctions]).
 */
class ThemeTernaryFunction<A, OA : ObservableValue<A>, B, OB : ObservableValue<B>, C, OC : ObservableValue<C>>(
    argA: OA,
    argB: OB,
    argC: OC,
    lambda: (A, B, C) -> Theme
) : TernaryFunction<Theme, A, OA, B, OB, C, OC>(argA, argB, argC, lambda), ObservableTheme

// endregion Functions


